<template>
<b-modal v-model="showFlg"
         size="lg"
         header-bg-variant="light"
         :modal-class="'setHeight081'"
         :title="$t('common.buttons.DeliButton')"
         :hide-footer="true"
         @hide ="handleCancel"
         no-close-on-backdrop>
    <div class="tk012" v-cloak>
        <div class="pageFeed">
            <div class="section-inner">
                <h3 class="subTitle">{{$t('common.buttons.DeliButton')}}</h3>
                <div>
                    <!--page table -->
                    <table class="table" id="cart-history">
                        <tbody>
                            <tr class="tableTr">
                                <td class="tdkYmdList">
                                    <!--お届希望日-->
                                    <select name="hopeDay" id="hopeDay" class="hopeDay" v-model="tk013ReqModel.tdkYmd">
                                        <option v-for="day in tk013Init.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.KEY}}</option>
                                    </select>
                                    <!--お届希望時間帯-->
                                    <select name="hopeTime" id="hopeTime" class="hopeTime" v-model="tk013ReqModel.tdkTimeKbn">
                                        <option v-for="time in tk013Init.tdkTimeList" :value="time.KEY" :key="time.KEY" >{{time.VALUE}}</option>
                                    </select>  
                                </td>
                                <!-- 変更ボタン -->
                                <td class="btnChange">
                                    <a class="btnSubmit" @click="doUpdate(tk013ReqModel.tdkYmd,tk013ReqModel.tdkTimeKbn)"><font>{{$t('common.buttons.change')}}</font></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <b-btn size="sm" class="btn btn-sm btn-secondary" variant="secondary" @click="showFlg = false">
                    {{$t('common.buttons.close')}}
                </b-btn>
            </div>
        </div>
    </div>
</b-modal>
</template>

<script>
import axios from "assets/js/request";
import common from 'assets/js/common';
import PageFeed from "../commonParts/PageFeedTdk";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import EventBus from "assets/js/eventBus";

export default {
    name: "TK037MemberTeikiIkkatuTdkList",
    components: {
        PageFeed,
        InputNumber,
        EventBus,
        Breadcrumb
    },
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        data:{
            tdkYmd:null,
            teikiNo:null,
            yoteiNo:null,
            tdkTimeKbn:null,
            teikiCdTypical:null
        }
    },
    data: function() {
        return {
            tk013ReqModel:{
                tdkYmd:null,
                teikiNo:null,
                yoteiNo:null,
                tdkTimeKbn:null
            },
            tk013Init:{
                tdkYmdList:{},
                tdkTimeList:{}
            },
            queryData:null,
            SiteConstants: SiteConstants,
            showFlg: true,
            site: ""
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.tk013ReqModel.teikiNo = _this.data.teikiNo;
        _this.tk013ReqModel.teikiCdTypical = _this.data.teikiCdTypical;
        _this.tk013ReqModel.yoteiNo = _this.data.yoteiNo;
        _this.tk013ReqModel.tdkYmd = _this.data.tdkYmd;
        _this.tk013ReqModel.tdkTimeKbn = _this.data.tdkTimeKbn;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK037 + _this.$UrlConstants.DO_INIT, _this.tk013ReqModel).then(function(response) {
            if(response.data.isLogin == false){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
            }else{
                _this.tk013Init = response.data;
            }
        }).catch(function(error) {
            common.errorAPI(error);
        });
    },

    methods: {
        /**
         * delete favorite product
         * @param {String} tdkMSeq, tdk product
         */
        doUpdate: function(tdkYmd, tdkTimeKbn){
            var _this = this;
            var rs;
            var tdkTimeValue;
            _this.tk013ReqModel.teikiNo = _this.data.teikiNo;
            _this.tk013ReqModel.teikiCdTypical = _this.data.teikiCdTypical;
            _this.tk013ReqModel.yoteiNo = _this.data.yoteiNo;
            _this.tk013ReqModel.tdkYmd = tdkYmd;
            _this.tk013ReqModel.tdkTimeKbn = tdkTimeKbn;
            _this.tk013ReqModel.updateFlg = '1';
            if (tdkYmd == null || tdkYmd == '' || tdkYmd == undefined) {
                alert("お届希望日を入力してください。");
                return false;
            }
            for(var i = 0; i < _this.tk013Init.tdkTimeList.length; i++){
                if(_this.tk013Init.tdkTimeList[i].KEY == tdkTimeKbn){
                    tdkTimeValue = _this.tk013Init.tdkTimeList[i].VALUE;
                }
            }
            rs = confirm(tdkYmd + " " + tdkTimeValue + _this.$i18n.t('tk001.labels.confirmMess2'));
            if(rs){
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK035 + _this.$UrlConstants.DO_UPDATE, _this.tk013ReqModel).then(function(response) {
                    if(response != null && response != undefined){
                        _this.tk013Init = response.data;
                    }
                })
                .catch(function(error) {
                    common.errorAPI(error);
                });
            }else{
                return false;
            }
            _this.showFlg = false;
        },
        handleCancel(evt){
            evt.preventDefault();
            this.$emit("data-selected", null);
            this.showFlg = false;
        } 
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    }
}
</script>